export default __webpack_public_path__ + "locales/it/DataReassignmentDialog.json?hash=651f3051244aa65ab958d1a3be5be9bf";